import { makeRequest } from 'utils/requestLogger';

export default (live_discussion_id, courseWorkID) =>
    makeRequest(
        'put',
        `/api/live_discussions/${live_discussion_id}/sync-course-work/${courseWorkID}`
    );



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/syncCourseWork.js